// extracted by mini-css-extract-plugin
export default {"center":"Search_center__DutD4","card":"Search_card__hsORp","search":"Search_search__+Dbmt","iconSearch":"Search_iconSearch__QnHR6"};